import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { date_format } from '@/constant/formats';

import 'dayjs/locale/de';
// require('dayjs/locale/de');

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const getTimeInAppTimeZone = (timeString: string) =>
  dayjs(timeString, 'HH:mm').format('HH:mm:ssZ');

export const getTimeInUTC = (timeString: string, date?: string) => {
  const currentDate = date || dayjs().format('YYYY-MM-DD');
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return dayjs
    .tz(`${currentDate} ${timeString}`, 'YYYY-MM-DD HH:mm', userTimezone)
    .utc()
    .format('HH:mm:ss');
};

export const parseTimeWithTimeZone = (timeString: string) =>
  dayjs(timeString, 'H:mm:ssZ').format('HH:mm');

export const parseTimeZoneDateWithoutFormat = (timeString: string) => {
  return dayjs(timeString);
};

export const getDateTimeWithAppTimeZone = (timeString: Date | string | null) =>
  timeString
    ? dayjs(timeString).utc().tz('Europe/Berlin').format('YYYY-MM-DD HH:mm:ss')
    : dayjs().utc().tz('Europe/Berlin').format('YYYY-MM-DD HH:mm:ss');

/**
 * Get formatted date and time from time string
 *
 * @param timeString Date or string to parse
 * @returns {full, date, time}
 */
export const getDateTime = (
  timeString: Date | string | null,
  dateFormat = date_format
): { full: string; date: string; time: string } | null => {
  if (!timeString) {
    return null;
  }
  return {
    full: timeString
      ? dayjs(timeString).format(`${dateFormat} H:mm`)
      : dayjs().format(`${dateFormat} H:mm`),
    date: timeString
      ? dayjs(timeString).format(`${dateFormat}`)
      : dayjs().format(`${dateFormat}`),
    time: timeString
      ? dayjs(timeString).format('HH:mm')
      : dayjs().format('HH:mm'),
  };
};

/**
 * Get formatted date in MMM D, YYYY format. e.g., Jan 1, 2022
 *
 * @param timeString Date or string to parse
 * @param locale Locale to use, default is 'de'
 * @returns {string}
 */
export const getFormattedDate = (
  timeString: Date | string,
  locale = 'de'
): string => {
  return dayjs(timeString).locale(locale).format('ll');
};

export const compareIfGreaterThen = (date1: string, date2: string) => {
  return dayjs(date1).isBefore(dayjs(date2)) ? -1 : 1;
};

export const getCurrentDayMonthYear = (locale = 'de') => {
  return {
    weekday: dayjs().locale(locale).format('dddd'),
    month: dayjs().locale(locale).format('MMMM'),
    year: dayjs().locale(locale).format('YYYY'),
  };
};

export const getDateWithTimeFormat = (date: any) => {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
};

export const getLocalisedDate = (
  date: string,
  locale: string,
  formate: string
) => {
  return dayjs(date).locale(locale).format(formate);
};
